{
  "ingestionFunctionNames": [
    "sku",
    "availability",
    "collection",
    "warehouse",
    "channel",
    "sale_base_data",
    "sale_tables",
    "sale_derived",
    "market",
    "customer",
    "weights",
    "stock_record",
    "incoming_order",
    "exchange_rates",
    "vendor",
    "forecast_metadata",
    "npi_forecast",
    "seasonality_profiles",
    "forecast_variant",
    "inventory_location",
    "allocation_location",
    "allocation_rate_of_sale",
    "allocation_sale",
    "hakio_meta",
    "company_settings",
    "nearest_neighbor",
    "matches",
    "custom_seasonality",
    "ingested_match_forecast",
    "comparison_fields",
    "imputes",
    "model_weights",
    "consistency_checks",
    "variant_warehouse_channel",
    "return_rates"
  ],
  "ingestionFunctionNamesNotRelevantForForecast": [
    "availability",
    "sale_base_data",
    "sale_tables",
    "sale_derived",
    "market",
    "stock_record",
    "inventory_location",
    "allocation_location",
    "allocation_rate_of_sale",
    "allocation_sale",
    "consistency_checks",
    "exchange_rates"
  ],
  "dsPipelineNames": ["collections", "npi", "sales_based"],
  "fuzzyMatchOrgIds": [
    "agent_provocateur",
    "by_bar",
    "carhartt_wip",
    "colorful_standard",
    "dilling",
    "exercere",
    "fiberpartner",
    "g_star",
    "hummel",
    "insight_cosmetics",
    "knowledgecotton_apparel",
    "laagam",
    "les_deux",
    "marimekko",
    "mayafreya",
    "mey",
    "mos_mosh",
    "oppo",
    "organic_basics",
    "oversized_lifting_club",
    "palmers",
    "pentland",
    "pitaya",
    "redefined_fashion",
    "samsoe_samsoe",
    "shaping_new_tomorrow",
    "splendid",
    "startex",
    "strauss",
    "suit_club",
    "swim_usa",
    "tekla",
    "teveo",
    "winther_studio",
    "zizzi"
  ],
  "companiesAllowedToBeDeleted": [
    "rito",
    "ditur",
    "loavies",
    "nordisk",
    "lisen",
    "dk_company",
    "dk_company_kaffe",
    "dk_company_matinique",
    "hummel_huge",
    "swim_usa",
    "vand_de_velde",
    "no_excess",
    "premier_is",
    "venderbys"
  ],
  "hakioSlackUsers": {
    "anders@hakio.com": "U05U62QUU04",
    "emil@hakio.com": "U080VMKV6CT"
  },
  "tagGroups": {
    "migrationFail": "anders@hakio.com",
    "forecastInsertFail": "emil@hakio.com",
    "companySpecifyWarning": {},
    "otherError": "anders@hakio.com"
  }
}